/**
 * Where the photo sits inside the frame, in frame pixels. Exported and pure so
 * the arithmetic that decides what the illustrator receives can be checked
 * without a browser — see cropGeometry.selfcheck.mjs.
 *
 * `fill` takes the larger scale so the frame is covered; `fit` takes the smaller
 * so the whole photo survives. Everything else follows from that one choice.
 */
export function geom(nat, f, fit, zoom = 1, offset = { x: 0, y: 0 }) {
    if (!nat || !nat.w || !nat.h) return null;
    const base = fit
        ? Math.min(f.w / nat.w, f.h / nat.h)
        : Math.max(f.w / nat.w, f.h / nat.h);
    const scale = base * zoom;
    const dw = nat.w * scale, dh = nat.h * scale;
    // How far it can travel before an edge would show inside the frame.
    const room = { x: Math.max(0, (dw - f.w) / 2), y: Math.max(0, (dh - f.h) / 2) };
    const at = {
        x: Math.min(room.x, Math.max(-room.x, offset.x)),
        y: Math.min(room.y, Math.max(-room.y, offset.y)),
    };
    return { scale, dw, dh, room, offset: at,
             dx: f.w / 2 - dw / 2 + at.x, dy: f.h / 2 - dh / 2 + at.y };
}
